import SystemTopBarLayout from "../../../layouts/SystemTopBarLayout";
import SystemExerciserLogoImage from "../../../images/SystemExerciserLogoImage";
import ExerciserProgressBar from "./ExerciserProgressBar";
import SystemDesktopTabletLeaveExerciserButton from "../../../buttons/SystemDesktopTabletLeaveExerciserButton";
import {ExerciserLogoTextSize} from "../../../../controllers/SystemExerciserLogoTextController";

export default function ExerciserTopBar({onLeaveFlashPressed, currentIndex, total}) {
    // Used in Exercisers to display top bar with
    // current progress and leave exercisers button

    // PROPERTIES
    const currentProblemIndex = currentIndex + 1

    // BUILD
    return (
        <SystemTopBarLayout>
            <SystemExerciserLogoImage exerciserLogoSize={ExerciserLogoTextSize.XSMALL} />
            <ExerciserProgressBar currentProblem={currentProblemIndex}
                                  total={total} />
            <SystemDesktopTabletLeaveExerciserButton onLeaveExerciserPressed={onLeaveFlashPressed} />
        </SystemTopBarLayout>
    );
}